import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { IComplaintSummary } from "./complaintSummary.types"
import { ComplaintSummary } from "./complaintSummary"
import { GetComplaintsSummaryQuery } from "@/api/hasura/generated/graphql"

export type ComplaintsSummaryRaw = GetComplaintsSummaryQuery

export const ComplaintSummaryParser: IParser<
  IComplaintSummary,
  ComplaintsSummaryRaw
> = {
  toDomain: (data: ComplaintsSummaryRaw): IComplaintSummary => {
    try {
      return new ComplaintSummary(
        data.complaint_aggregations[0].open,
        data.complaint_aggregations[0].ombudsman,
        data.complaint_aggregations[0].cab,
        data.complaint_aggregations[0].ehu,
        data.complaint_aggregations[0].exec,
        data.complaint_aggregations[0].newer_than_5_weeks,
        data.complaint_aggregations[0].older_than_5_weeks,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
